<template>
  <div>
    <Authenticate/>
    <v-container>
    <v-data-table
    :headers="headers"
    :items="filelogs"
    :items-per-page="15"
    class="elevation-1">
    <template v-slot:top>
      <v-toolbar color="white" flat>
        <v-toolbar-title>Upload File</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <alert :message=message :variant='variant' v-if="showMessage">
        </alert>
        <v-alert :value="showError" type="error" dismissible>{{ error }}
        </v-alert>
        <v-spacer></v-spacer>
        <v-dialog max-width="500px" v-model="dialog">
          <template v-slot:activator="{ on }">
            <v-btn class="mb-2" color="primary" dark v-on="on">Add Filename</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row align="start" justify="start">
                  <v-col cols="12" md="6" sm="8">
                    <v-text-field label="File Name"
                                  placeholder="sample.txt"
                                  required
                                  v-model="editedItem.file_name">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" sm="8">
                    <v-text-field label="File Folder"
                                  placeholder="Documents/cars.csv"
                                  required
                                  v-model="editedItem.file_folder">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6" sm="8">
                    <v-text-field label="Organisation"
                                  placeholder="Rsi"
                                  required
                                  v-model="editedItem.organisation">
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="close" color="blue darken-1" text>Cancel</v-btn>
              <v-btn @click="save" color="blue darken-1" text>UploadSave</v-btn>
            </v-card-actions>

          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-text-field
          @input="search"
          color="success"
          placeholder="Search"
        ></v-text-field>

    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon @click="editItem(item)" class="mr-2" small>mdi-pencil</v-icon>
      <v-icon @click="deleteItem(item)" class="mr-2" small>mdi-delete</v-icon>

    </template>
  </v-data-table>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import Alert from './Alert.vue';
import Authenticate from './Authenticate.vue';

export default {
  data() {
    return {
      dialog: false,
      editedIndex: -1,
      headers: [
        {
          text: 'Log ID',
          align: 'start',
          sortable: false,
          value: 'key',
        },
        { text: 'File Name', value: 'file_name' },
        { text: 'File Folder', value: 'file_folder' },
        { text: 'Creation date', value: 'current_date' },
        { text: 'Organisation', value: 'organisation' },
        { text: 'Author', value: 'author' },
        { text: 'Actions', value: 'actions' },
      ],
      filelogs: [],
      editedItem: {
        key: '',
        file_name: '',
        file_folder: '',
        organisation: '',
        author: this.$store.getters.userMail,
      },
      defaultItem: {
        key: '',
        file_name: 'sample',
        file_folder: 'c:/',
        organisation: '',
        author: this.$store.getters.userMail,
      },
      message: '',
      variant: 'success',
      showMessage: false,
      error: '',
      showError: false,
    };
  },
  components: {
    Authenticate,
    alert: Alert,
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add Filename' : 'Edit Filename';
    },
  },
  watch: {
    dialog(val) {
      // eslint-disable-next-line
      val || this.close();
    },
  },
  methods: {
    getFilelogs(path = '/api/uploadfile') {
      axios.get(path)
        .then((res) => {
          this.filelogs = res.data.filelogs;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
          if (error.response.status === 403) {
            this.$root.$emit('signout');
          }
        });
    },

    search(val) {
      console.log(val);
      const path = `/api/uploadfile?q=${val}`;
      this.getFilelogs(path);
    },

    deleteItem(item) {
      // eslint-disable-next-line
      confirm('Are you sure you want to delete this item?') && this.removeFilelogs(item.key);
    },
    editItem(item) {
      this.editedIndex = this.filelogs.indexOf(item);
      // eslint-disable-next-line
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        // eslint-disable-next-line
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      if (this.editedIndex > -1) {
        this.editFilelogs(this.editedItem);
      } else {
        this.addFilelogs(this.editedItem);
      }
      this.close();
    },
    addFilelogs(payload) {
      const path = '/api/uploadfile';
      axios.post(path, payload)
        .then((res) => {
          this.getFilelogs();
          this.message = res.data.message;
          if (this.message !== 'Filename added!') {
            this.variant = 'danger';
          } else {
            this.variant = 'success';
          }
          this.showMessage = true;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
          this.error = error.response.data.error;
          this.showError = true;
          this.getFilelogs();
        });
    },
    removeFilelogs(FileId) {
      const path = `/api/uploadfile/${FileId}`;
      axios.delete(path)
        .then(() => {
          this.getFilelogs();
          this.message = 'Filename removed!';
          this.variant = 'success';
          this.showMessage = true;
        })
        .catch((error) => {
          // eslint-disable-next-line
      console.error(error);
          this.getFilelogs();
        });
    },
    editFilelogs(payload) {
      const fileId = payload.key;
      const path = `/api/uploadfile/${fileId}`;
      axios.post(path, payload)
        .then((res) => {
          this.getFilelogs();
          this.message = res.data.message;
          if (this.message !== 'Filename modified!') {
            this.variant = 'danger';
          } else {
            this.variant = 'success';
          }
          this.showMessage = true;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error(error);
          this.error = error.response.data.error;
          this.showError = true;
          this.getFilelogs();
        });
    },
  },
  created() {
    this.getFilelogs();
  },
};
</script>
